import axios from 'axios';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const baseUrl = process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_BACKEND_LOCAL_API
  : process.env.REACT_APP_BACKEND_LIVE_API;

export default function Profile() {
  const history = useHistory();
  const [Name, setName] = useState('');
  const [Phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
    try {
      await axios.patch(baseUrl + 'user/edit', { Name, Phone }, { headers });
      history.push('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Update failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h4 className="text-uppercase font-weight-bold mb-1">Update Admin Profile</h4>
        <p className="page-subtitle">Change your name and mobile.</p>
      </div>
      <div className="admin-card">
        <div className="admin-card-header">Profile</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Name"
                  value={Name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor="phone">Mobile</label>
                <input
                  type="tel"
                  className="form-control"
                  id="phone"
                  name="phone"
                  placeholder="Phone"
                  value={Phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
            </div>
            <button type="submit" className="btn btn-success" disabled={loading}>
              {loading ? 'Saving...' : 'Save'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
